import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanCreateNote = (): boolean => {
  const [canCreateNote, setCanCreateNote] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const createSelfPermission: Permission = {
    resource: 'notes',
    action: 'createbasic',
    scope: 'self',
  };
  const createAllPermission: Permission = {
    resource: 'notes',
    action: 'createbasic',
    scope: 'all',
  };

  const canCreateSelf = useHasPermission(user, createSelfPermission);
  const canCreateAll = useHasPermission(user, createAllPermission);

  React.useEffect(() => {
    setCanCreateNote(canCreateAll || canCreateSelf);
  }, [canCreateSelf, canCreateAll]);

  return canCreateNote;
};
